import { render, staticRenderFns } from "./WxGoods.vue?vue&type=template&id=2d6bf91c&scoped=true&"
import script from "./WxGoods.vue?vue&type=script&lang=js&"
export * from "./WxGoods.vue?vue&type=script&lang=js&"
import style0 from "./WxGoods.vue?vue&type=style&index=0&id=2d6bf91c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bf91c",
  null
  
)

export default component.exports